import _ from 'lodash'
import { EmployerType } from '../../core/constant'

if (!window.SETS) {
    window.SETS = {}
}

// 当前运行环境 production / development
const env = process.env

_.assign(env, window.SETS ? window.SETS.env : {})

// 版本
// const version = process.env.version

// 公司信息
const company = window.SETS.company || {}

// 登录用户信息; 并追加了一个是否已登录标志 "login": true/ false
const user = window.SETS ? window.SETS.user : {}

// 追加用户角色 isExaminee / isExaminer
if (user && user.employerType) {
    // 应聘者/ 学生
    user.isExaminee = +user.employerType === EmployerType.EXAMINEE
    // 招聘者/ 老师
    user.isExaminer = +user.employerType === EmployerType.EXAMINER
    // 应聘者/ 学生方式注册
    user.isRegisteredExaminee = +user.registerType === EmployerType.EXAMINEE
    // 招聘者/ 老师方式注册
    user.isRegisteredExaminer = +user.registerType === EmployerType.EXAMINER
}

// 浏览器地址栏中的 params
const params = window.SETS ? window.SETS.params : {}

// Request 中以 "sets_" 开头的的 params , 注意 "sets_" 已经被去掉了
const request = window.SETS ? window.SETS.request : {}

// 视图局部变量
const local = window.SETS ? window.SETS.local : {}

export {
  env, user, company, params, request, local
}



// WEBPACK FOOTER //
// ./bootsets/runtime/index.js